//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getQueryVariable, system, isApp } from '../../util/const'

export default {
  data () {
    return {
      fid: getQueryVariable('fid'),
      happiness: getQueryVariable('happiness'),
      attractiveness: getQueryVariable('attractiveness'),
      desc: getQueryVariable('desc'),
      photo: 'static/img/71X58PICNjx_1024.jpg',
      user: {
        phone: '',
        code: ''
      },
      second: 0,
      phoneErr: false,
      codeErr: false,
      clicked: false
    }
  },
  created () {
    if (isApp()) {
      this.getShangtangImg()
    } else {
      this.getPhoto()
    }
  },
  watch: {
    'user.phone': {
      handler (v) {
        this.phoneErr = !v
      },
      deep: true
    },
    'user.code': {
      handler (v) {
        this.codeErr = !v
      },
      deep: true
    }
  },
  methods: {
    getPhoto () {
      this.$http.get('/v1/api/user/none/getUrlByFid', { fid: this.fid }).then(res => {
        this.photo = res.data.body.fid
      })
    },
    getShangtangImg () {
      const name = system()
      const isAndroid = name === 'android' // android终端
      const isiOS = name === 'ios' // ios终端
      let obj = JSON.stringify({ fid: this.fid })
      if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.getShangtangImg(obj)
      }

      if (isiOS) {
        // 调用原生的分享功能
        window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getShangtangImg && window.webkit.messageHandlers.getShangtangImg.postMessage(obj)
      }

    },
    getPhoneCode () {
      this.timeSet()
      this.$http.post('/v1/api/user/largescreen/none/setVerifyCode', { body: { phone: this.user.phone } }).then(res => {
        console.log(res)
        // this.photo = res.data.body.fid
      })
    },
    timeSet () {
      this.second = 60
      let _t = setInterval(() => {
        this.second--
        if (this.second === 0) {
          clearInterval(_t)
        }
      }, 1000)
    },
    checkData () {
      let phoneReg = /^[\d]+$/
      this.phoneErr = !phoneReg.test(this.user.phone)
      this.codeErr = !this.user.code
    },
    receive () {
      this.checkData()
      if (this.phoneErr || this.codeErr || this.clicked) {
        return
      }
      this.clicked = true
      this.$http.post('/v1/api/user/largescreen/none/registPhone', {
        body: {
          phone: this.user.phone,
          code: this.user.code,
          url: this.photo
        }
      }).then(res => {
        this.clicked = false
        if (res.data.body.code === 2) {
          this.$toast({ msg: '验证码错误', time: 500 })
        } else {
          this.$router.push({ path: '/downMylink/' + res.data.body.code })
        }

      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/shangtang/index.vue